import { useState } from "react";
import PageSection from "@/common/page-section.common";
import { useTranslations } from "next-intl";

export const RequiredDocuments = () => {
  const t = useTranslations();
  const documents = [
    "Aadhaar Card & PAN Card",
    "Land Records (Form 7/12)",
    "Village Map with Form 'A' Annexure",
    "Google Map with Land Boundaries",
    "Detailed Application Proposal",
    "Ownership/Lease Agreement (P1)",
    "Project Layout Plan",
    "Structure Details",
    "Grampanchayat NOC",
    "Topography Map & Site Photographs",
    "Protected Area Distance Mapping",
    "Corridor Plan",
  ];

  const [showAll, setShowAll] = useState(false);
  const mobileVisibleDocs = showAll ? documents : documents.slice(0, 5);

  return (
    <div className="bg-slate-200">
      <PageSection heading="Required Documents">
        <div className="p-2">
          <div className="hidden lg:grid grid-cols-4 gap-6">
            {documents.map((doc, index) => (
              <div
                key={index}
                className="border rounded-lg p-3 shadow-lg bg-white border-l-6 border-green-700"
              >
                {t(doc)}
              </div>
            ))}
          </div>

          <div className="lg:hidden">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {mobileVisibleDocs.map((doc, index) => (
                <div
                  key={index}
                  className="border rounded-lg p-3 shadow-lg bg-white border-l-6 border-green-700"
                >
                  {t(doc)}
                </div>
              ))}
            </div>
            {documents.length > 5 && (
              <div className="mt-4 text-center">
                <button
                  className="text-white font-medium bg-green-700 w-full rounded-lg p-2"
                  onClick={() => setShowAll(!showAll)}
                >
                  {showAll ? "Show Less" : "Show More"}
                </button>
              </div>
            )}
          </div>
        </div>
      </PageSection>
    </div>
  );
};

export default RequiredDocuments;
